// Single place for every customer/admin-visible name (director 11 Oct 2026).
// "Insul" alone must never appear - another company carries that name. Product names will change again: edit here only.
export const BUSINESS_NAME = 'Insul Nutrients';
export const BUSINESS_NAME_UPPER = 'INSUL NUTRIENTS';
export const SUITE_NAME = 'MyIN';
export const TIER_NAMES = {
  wellness: 'IN Wellness',
  cdm: 'IN CDM',
  weight_loss: 'IN Weight Loss',
};
